import { render, staticRenderFns } from "./FormInputs.vue?vue&type=template&id=38ffc614"
import script from "./FormInputs.vue?vue&type=script&lang=js"
export * from "./FormInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports